<template>
    <div>
        <div id="section-1">
            <div class="container">
                <div class="row">
                    <div class="col-md-7">
                        <h1>Download the snaring report</h1>
                        <div class="row">
                            <div class="col-md-9">
                                <p>Our latest report shows that snaring impacts 80% of Southeast Asia’s land mammal families, including the mighty tiger.</p>
                                <p>Find out how snares are emptying our forests and contributing to a wildlife extinction crisis.</p>
                                
                                <form @submit.prevent="downloadReport">
                                    <div class="mb-2 row" v-if="form._utm == 'false'">
                                        <div class="col-6 form-group">
                                            <input type="text" class="form-control" placeholder="First name" required v-model="form.firstname">
                                        </div>
                                        <div class="col-6 form-group">
                                            <input type="text" class="form-control" placeholder="Last name" required v-model="form.lastname">
                                        </div>
                                        <div class="col-md-12 form-group">
                                            <input type="email" class="form-control" placeholder="email@address.com" required v-model="form.email">
                                        </div>
                                        <div class="col-md-12 form-group">
                                            <input type="text" class="form-control mb-1" placeholder="Phone number (+65)" required v-model="form.phone">
                                            <p class="note">By downloading the report, I agree to receive updates from WWF-Singapore in accordance with our <a href="https://www.wwf.sg/wwf_singapore/pdp_policy/" class="text-orange">Personal Data Protection Policy</a>.</p>
                                        </div>
                                    </div>
                                    <button type="submit">DOWNDLOAD NOW ></button>
                                </form>
                                
                            </div>
                            <div class="col-md-3"></div>
                        </div>
                    </div>
                    <div class="col-md-5"></div>
                </div>
            </div>
        </div>
        <div id="section-2">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="text-center">WHAT ARE SNARES?</h1>
                        <p>Snares are trap devices laid out in forests that can capture all kinds of animals that encounter them—including bears, tigers, tapirs, deers, elephants and many more.</p>
                        <p><b>What’s worse?</b> They can be made with easily available materials like nylon, wire or cable!</p>
                        <p>Did you know that the widespread practice of snaring sets off a chain of human wildlife contact, and has a high chance of causing zoonotic diseases like COVID-19? Download our report to find out more about how the snaring crisis affects people, nature and wildlife.</p>
                        <div class="row pt-md-5 mb-5">
                            <div class="col-md-4">
                                <img src="/storage/imgs/snaringcrisis/Snaring-Report-1-min.jpg" alt="">
                            </div>
                            <div class="col-md-4">
                                <img src="/storage/imgs/snaringcrisis/Snaring-Report-2-min.jpg" alt="">
                            </div>
                            <div class="col-md-4">
                                <img src="/storage/imgs/snaringcrisis/Snaring-Report-3-min.jpg" alt="">
                            </div>
                        </div>
                        <div class="text-center">
                            <a href="#" v-on:click="downloadReportBottomButton()">DOWNDLOAD THE REPORT ></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="section-3">

        </div>
    </div>
</template>

<script>
export default {
    props: ['utm' , 'token_csrf'],
    data(){
        return{
            form:{
                _utm : this.utm,
                firstname:"",
                lastname:"",
                email:"",
                phone:"",
                _token: this.token_csrf,
            }
        }
    },
    created(){

    },
    methods:{
        downloadReport(){

            if (this.utm == "false") {
                fetch('/snaringcrisis/addtoac',{
                    method: 'post',
                    body: JSON.stringify(this.form),
                    headers: {
                        'content-type' : 'application/json',
                        'Accept': 'application/json',
                    }
                })
                .then(res => res.json())
                .then(res => {
                    if(res.status == "success"){
                
                        const link = document.createElement('a')
                        link.href = "/storage/snaring_crisis_pdf/Southeast Asia Snaring Crisis WWF.pdf";
                        link.download = "Southeast Asia Snaring Crisis WWF";
                        link.click();

                        Swal.fire(
                            'Successfully downloaded the report',
                            'Thank you! Your download is starting. We will also send you the report via email.',
                            'success'
                        );

                        
                    }
                    
                })
                .catch(err => console.log(err));
            }
            else{
                

                const link = document.createElement('a')
                link.href = "/storage/snaring_crisis_pdf/Southeast Asia Snaring Crisis WWF.pdf";
                link.download = "Southeast Asia Snaring Crisis WWF";
                link.click();

                Swal.fire(
                    'Successfully downloaded the report',
                    'Thank you! Your download is starting. We will also send you the report via email.',
                    'success'
                );
                
            }
            
        },
        downloadReportBottomButton(){
            
            if (this.utm == "false") {
                console.log(this.utm)

                Swal.fire(
                    'Unable to download report',
                    'Please fill in all the fields required.',
                    'error'
                );
            }
            else{
                
                const link = document.createElement('a')
                link.href = "/storage/snaring_crisis_pdf/Southeast Asia Snaring Crisis WWF.pdf";
                link.download = "Southeast Asia Snaring Crisis WWF";
                link.click();

                Swal.fire(
                    'Successfully downloaded the report',
                    'Thank you! Your download is starting. We will also send you the report via email.',
                    'success'
                );
            }
        }
    }
}
</script>

<style scoped>
    #section-1{
        padding-top: 7rem;
        padding-bottom: 10rem;
        background-image: url("/storage/imgs/snaringcrisis/Snaring-Report-Header-min.jpg");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }
    #section-1 h1{
        color:white;
        font-family: "WWF";
        line-height: 1;
        font-size: 3.5rem;
        margin-bottom: 2rem;
    }
    #section-1 p{
        color:white;
        
    }
    #section-1 .note{
        color: white;
        font-size: 0.6rem;
    }
    #section-1 button{
        font-family: "WWF";
        border: none;
        background-color: #f07d00;
        color:white;
        font-size: 1.5rem;
        padding: 7px 20px;
        text-decoration: none;
    }
    #section-2{
        padding-top: 3rem;
        padding-bottom: 4rem;
    }
    #section-2 h1{
        font-family: "WWF";
        font-size: 3rem;
        margin-bottom: 20px;
    }

    #section-2 img{
        width: 100%;
    }
    #section-2 .col-md-4{
        padding: 20px 40px;
    }
    #section-2 a{
        font-family: "WWF";
        border: none;
        background-color: #f07d00;
        color:white;
        font-size: 1.5rem;
        padding: 7px 20px;
        text-decoration: none;
    }
</style>